// Метка времени операции: <миллисекунды, 13 цифр>-<счётчик, 4 hex>-<UUID создателя>.
// Гибридные логические часы: метка не меньше времени устройства и больше любой уже
// выданной или полученной. Формат и правила те же, что на узлах (system-service).
const TIME_PATTERN = /^(\d{13})-([0-9a-f]{4})-([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/
const MAX_COUNTER = 0xffff

export interface IClock {
  millis: number
  counter: number
}

export function formatOperationTime(millis: number, counter: number, origin: string): string {
  return `${String(millis).padStart(13, '0')}-${counter.toString(16).padStart(4, '0')}-${origin.toLowerCase()}`
}

export function isOperationTime(time: unknown): time is string {
  return typeof time === 'string' && TIME_PATTERN.test(time)
}

export function operationTimeOrigin(time: string): string {
  return time.slice(19)
}

export function isLaterTime(time: string, than: string | undefined): boolean {
  return than === undefined || time > than
}

/** Следующее значение часов для новой операции */
export function nextClock(clock: IClock, now: number): IClock {
  if (now > clock.millis) {
    return { millis: now, counter: 0 }
  }
  if (clock.counter >= MAX_COUNTER) {
    return { millis: clock.millis + 1, counter: 0 }
  }

  return { millis: clock.millis, counter: clock.counter + 1 }
}

/** Часы не отстают от метки полученной операции */
export function moveClock(clock: IClock, time: string): IClock {
  const match = TIME_PATTERN.exec(time)
  if (!match) {
    return clock
  }
  const millis = Number(match[1])
  const counter = parseInt(match[2], 16)
  const isBehind = millis > clock.millis || (millis === clock.millis && counter > clock.counter)

  return isBehind ? { millis, counter } : clock
}
